import React, { useEffect, useRef, useState } from "react";
import useWindowDimensions from "../hooks/useWindowsDimensions";
import { IframeBlockerOverlay } from "./IframeBlockerOverlay";

export const Modal_Frame = ({
  id,
  isOpen,
  onClose,
  title,
  size,
  url_frame,
  zIndex,
  onFocusModal,
  isMinimize,
  minimizeFunction,
  sidebar_info,
  SelectedAppID,
  isComponent,
  selectedUserId,
  componentName,
}) => {
  const [isMaxPage, setIsMaxPage] = useState(true);
  const [sizePage, setSizePage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [position, setPosition] = useState({ x: 300, y: 50 });
  const modalRef = useRef(null);
  const offset = useRef({ x: 0, y: 0 });
  const dimensions = useWindowDimensions();
  const [resizeModalDimensions, setResizeModalDimensions] = useState({
    x: 1200,
    y: 770,
  });
  const [isAutomaticSize, setIsAutomaticSize] = useState(false);
  const [resizing, setResizing] = useState({ active: false, direction: null });

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "W-[800px] h-[700px]",
    full: "w-full h-full",
  };

  useEffect(() => {
    if (modalRef.current) {
      const rect = modalRef.current.getBoundingClientRect();
      //console.log("Dimension:", rect);
      //setResizeModalDimensions({ x: rect.width, y: rect.height });
    }
  }, [isMaxPage]);

  useEffect(() => {
    onFocusModal(id)
  }, []);


  useEffect(() => {
    setSizePage(size);
  }, []);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    } else {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [dragging, position]);

  useEffect(() => {
    if (resizing.active) {
      window.addEventListener("mousemove", handleMouseMoveResize);
      window.addEventListener("mouseup", onMouseUpResize);
    } else {
      window.removeEventListener("mousemove", handleMouseMoveResize);
      window.removeEventListener("mouseup", onMouseUpResize);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMoveResize);
      window.removeEventListener("mouseup", onMouseUpResize);
    };
  }, [resizing, position, resizeModalDimensions]);
  const MaxMinModal = () => {
    //console.log(isMaxPage);
    if (isMaxPage) {
      setIsAutomaticSize(true);
      setPosition({
        x: 0,
        y: 0,
      });
      setSizePage("full");
    } else {
      setIsAutomaticSize(false);
      setPosition({
        x: 300,
        y: 50,
      });
    }
    setIsMaxPage(!isMaxPage);
  };
  const onMouseDown = (e) => {
    offset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };

    setDragging(true);
    onFocusModal(id);
  };
  const onMouseMove = (e) => {
    if (!dragging || !isMaxPage) return;

    const leftX = e.clientX - offset.current.x;
    const leftY = e.clientY - offset.current.y;

    let maxX = dimensions.width - resizeModalDimensions.x - 5;
    const maxY = dimensions.height - resizeModalDimensions.y;

    if (sidebar_info.active) {
      maxX -= 1;
    }

    const newX = Math.min(Math.max(leftX, 0), maxX);
    const newY = Math.min(Math.max(leftY, 0), maxY);

    setPosition({ x: newX, y: newY });
  };
  const onMouseDownResize = (direction) => {
    //console.log("Se presiona resize ", direction);
    setResizing({ active: true, direction });
  };

  const handleMouseMoveResize = (e) => {
    if (!resizing.active) return;

    const deltaX = e.movementX;
    const deltaY = e.movementY;

    let newWidth = resizeModalDimensions.x;
    let newHeight = resizeModalDimensions.y;
    let newX = position.x;
    let newY = position.y;

    if (resizing.direction === "R") {
      // Resizing to the right
      let auxDimensions = dimensions.width - position.x;

      newWidth = Math.min(resizeModalDimensions.x + deltaX, auxDimensions);
      if (newWidth >= 400) {
        setResizeModalDimensions({ x: newWidth, y: newHeight });
      }
    } else if (resizing.direction === "B") {
      // Resizing to the bottom
      newHeight = Math.min(
        resizeModalDimensions.y + deltaY,
        dimensions.height - position.y
      );
      if (newHeight >= 400) {
        setResizeModalDimensions({ x: newWidth, y: newHeight });
      }
    } else if (resizing.direction === "L") {
      // Resizing to the left
      const nextWidth = resizeModalDimensions.x - deltaX;
      const nextX = position.x + deltaX;

      if (nextWidth > 400 && nextX >= 0) {
        // ancho mínimo = 100
        newWidth = nextWidth;
        newX = nextX;
        setResizeModalDimensions({ x: newWidth, y: newHeight });
        setPosition({ x: newX, y: newY });
      }
    } else if (resizing.direction === "T") {
      // Resizing to the top
      const nextHeight = resizeModalDimensions.y - deltaY;
      const nextY = position.y + deltaY;

      if (nextHeight > 400 && nextY >= 0) {
        // alto mínimo = 100
        newHeight = nextHeight;
        newY = nextY;
        setResizeModalDimensions({ x: newWidth, y: newHeight });
        setPosition({ x: newX, y: newY });
      }
    }
  };

  const onMouseUp = () => setDragging(false);
  const onMouseUpResize = () => setResizing({ active: false, direction: null });
  if (!isOpen) return null;

  return (
    <div>
      <div
        ref={modalRef}
        style={{
          left: position.x,
          top: position.y,
          zIndex: zIndex,
          width: isAutomaticSize ? undefined : `${resizeModalDimensions.x}px`,
          height: isAutomaticSize ? undefined : `${resizeModalDimensions.y}px`,
        }}
        className={`absolute bg-white rounded-lg shadow-lg w-full ${
          isAutomaticSize ? sizeClasses[sizePage] : ""
        } flex flex-col max-h-[95vh]  ${isMinimize ? "hidden" : ""}`}
      >
        <div
          className="absolute top-0 left-0 right-0 h-2 bg-white flex items-center justify-center cursor-row-resize"
          onMouseDown={() => onMouseDownResize("T")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute bottom-0 left-0 right-0 h-2 bg-white flex items-center justify-center cursor-row-resize"
          onMouseDown={() => onMouseDownResize("B")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute top-2 bottom-2 left-0 w-2 bg-white flex items-center justify-center cursor-col-resize"
          onMouseDown={() => onMouseDownResize("L")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute top-2 bottom-2 right-0 w-2 bg-white flex items-center justify-center cursor-col-resize"
          onMouseDown={() => onMouseDownResize("R")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="flex justify-between items-center border-b p-4 flex-shrink-0 cursor-move"
          onMouseDown={onMouseDown}
        >
          {dragging && <IframeBlockerOverlay />}
          <div>
            <h2 className="text-xs font-semibold">{title}</h2>
          </div>
          <div>
            <button
              onMouseDown={(e) => e.stopPropagation()}
              onClick={() => minimizeFunction(id)}
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold mx-2"
            >
              -
            </button>
            <button
              onMouseDown={(e) => e.stopPropagation()}
              onClick={MaxMinModal}
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold mx-2"
            >
              +
            </button>
            <button
              onMouseDown={(e) => e.stopPropagation()}
              onClick={() => onClose(id)}
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold mx-2"
            >
              &times;
            </button>
          </div>
        </div>
        <div className="h-full overflow-auto">
          {isComponent ? (
            componentName ? (
              React.createElement(componentName, {
                ApplicationId: SelectedAppID,
                UserId: selectedUserId,
                ModuleId: id,
              })
            ) : (
              <p>Error</p>
            )
          ) : url_frame ? (
            <iframe src={url_frame} className="w-full h-full" title={title} />
          ) : (
            <p>Error</p>
          )}
        </div>
      </div>
    </div>
  );
};
